import React from "react";
import { securityAndDataProtectionServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const SecurityAndDataServiceDetailPage = () => {
  const data = securityAndDataProtectionServiceData;
  return (
    <>
      <SEO {...seoData.securityData} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default SecurityAndDataServiceDetailPage;
